var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pb-10"},[_c('CrimeSearcher',{scopedSlots:_vm._u([{key:"extension",fn:function(){return [_c('CrimeAdminMenu')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }